<template>
  <span
    class="ui_checkbox"
    :class="{ on: !!this.value, disabled: !!this.disabled }"
    @click="onClick">
    <i class="icon icon--chkbox" :class="[{ unselect: this.unselect }, color]"></i>
    <span class="text"><slot/></span>
  </span>
</template>

<script>
export default {
  name: 'UiCheckbox',
  props: [
    'value',
    'labelText',
    'disabled',
    'unselect',
    'color'
  ],
  methods: {
    onClick (value) {
      if (!this.disabled) {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>

<style lang="scss">
.ui_checkbox {
  position: relative;
  cursor: pointer;
  transition: opacity 0.2s ease;

  .icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  &:nth-last-of-type(1) {
    margin-left: 18px;
  }
  .text {
    font-size: 14px;
    color: #2f2f2f;
    margin-left: 25px;
  }

  &.disabled {
    pointer-events: none;

    .text {
      color: #bbb !important;
    }
  }
}
</style>
